import { Navigation } from "./Navigation";
import { patterns } from "@/lib/assets";
import { cn } from "@/lib/utils";
import type { HTMLAttributes } from "react";

type HeroShellProps = HTMLAttributes<HTMLElement> & {
  innerClassName?: string;
};

export function HeroShell({
  className,
  children,
  innerClassName = "h-[var(--layout-platform-card-height-xl)]",
  ...props
}: HeroShellProps) {
  return (
    <section className={cn("flex w-full flex-col", className)} {...props}>
      <div className={cn("relative w-full overflow-hidden rounded-3xl bg-hero-gradient-base", innerClassName)}>
        <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
          <div className="hero-gradient-canvas" />
        </div>

        <div className="pointer-events-none absolute left-1/2 top-[var(--layout-hero-pattern-top-current)] h-[var(--layout-hero-pattern-size)] w-[var(--layout-hero-pattern-size)] -translate-x-1/2 opacity-40 mix-blend-screen md:opacity-60">
          <img src={patterns} alt="" className="block h-full w-full object-contain" loading="eager" decoding="async" />
        </div>

        <div className="relative z-10 h-full w-full">
          <div className="public-hero-navigation">
            <Navigation baseAnalyticsElementId="global-navigation:header" />
          </div>

          {children}
        </div>
      </div>
    </section>
  );
}
